import { IQueryOptions } from '@kurtosys/ksys-api-client/dist/models/commonTypes';
import { LinkFilter } from '../../configuration/LinkFilter';
import { BreakpointSize, Operator } from '../../../types';
import { FeedbackConfig } from '../FeedbackConfig';

interface Hideable {
    hide?: boolean;
    hideWhen?: 'inline' | 'dropdown';
}

interface BreakpointConditional {
    breakpoint: BreakpointSize;
    operator: Operator;
}

interface Hideable {
    hide?: boolean;
    hideWhen?: 'inline' | 'dropdown';
}

export interface IconOptions extends Hideable {
    filename: string;
    disabledFilename?: string;
    position?: 'before' | 'after';
}

export interface DownloadControlActions {
    checkboxOptions?: CheckboxOptions;
    countOptions?: CountOptions;
    disableExtendedInfo?: boolean;
    dropdownOptions?: DropdownOptions;
    elements?: Array<ActionOptions>;
    /**
     * To allow the disabled icons to be rendered if they are not supposed to render
     * @title Display Disabled Icons
     */
    displayDisabledIcons?: boolean;
    /**
     * This is generated by the document config in context
     */
    _documentDisplayName?: string;
}

export interface LabelOptions extends Hideable {
    label?: IQueryOptions;
    disabledLabel?: IQueryOptions;
}

export interface CopyUrlLabelOptions extends LabelOptions {
    successLabel?: IQueryOptions;
}

export interface IconOptions extends Hideable {
    filename: string;
    disabledFilename?: string;
}

export interface CopyUrlIconOptions extends IconOptions {
    successFilename: string;
}

export interface CheckboxOptions extends Hideable {
    labelOptions?: LabelOptions;
    iconOptions?: {
        checkedFilename?: string;
        uncheckedFilename?: string;
    };
}

export interface CountOptions extends Hideable {
    zeroCountOverride?: string;
    hideZeroCount?: boolean;
}

export interface DropdownOptions {
    labelOptions?: LabelOptions;
    showBreakpoints?: Array<BreakpointConditional>;
    iconOptions?: {
        collapsedFilename?: string;
        expandedFilename?: string;
    };
}

export enum ActionOptionType {
    copyUrl = 'copyUrl',
    download = 'download',
    link = 'link',
    preview = 'preview',
    title = 'title',
}

export interface BaseActionOptions {
    type: ActionOptionType;
    labelOptions?: LabelOptions;
    iconOptions?: IconOptions;
}

export interface CopyUrlActionOptions extends BaseActionOptions {
    type: ActionOptionType.copyUrl;
    url?: IQueryOptions;
    labelOptions?: CopyUrlLabelOptions;
    iconOptions?: CopyUrlIconOptions;
    feedback?: FeedbackConfig;
}

export interface DownloadActionOptions extends BaseActionOptions {
    type: ActionOptionType.download;
    url?: IQueryOptions;
}

export interface LinkActionOptions extends BaseActionOptions {
    type: ActionOptionType.link;
    linkId?: string;
    linkFilter?: LinkFilter;
    /**
     * This key is auto-generated by the config store and helps with setting up linked segmentation rules
     */
    _key?: string;
}

export interface PreviewActionOptions extends BaseActionOptions {
    type: ActionOptionType.preview;
    url?: IQueryOptions;
}

export interface TitleActionOptions
    extends Omit<BaseActionOptions, 'iconOptions'> {
    type: ActionOptionType.title;
}

export type ActionOptions =
    | CopyUrlActionOptions
    | DownloadActionOptions
    | LinkActionOptions
    | PreviewActionOptions
    | TitleActionOptions;



// WEBPACK FOOTER //
// ./src/models/configuration/explorer/DownloadControls.ts